var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.8C15 18.1198 15 17.2798 15.327 16.638C15.6146 16.0735 16.0735 15.6146 16.638 15.327C17.2798 15 18.1198 15 19.8 15H28.2C29.8802 15 30.7202 15 31.362 15.327C31.9265 15.6146 32.3854 16.0735 32.673 16.638C33 17.2798 33 18.1198 33 19.8V25.5C33 26.8978 33 27.5967 32.7716 28.1481C32.4672 28.8831 31.8831 29.4672 31.1481 29.7716C30.5967 30 29.8978 30 28.5 30C28.0114 30 27.7671 30 27.5405 30.0535C27.2383 30.1248 26.9569 30.2656 26.7185 30.4645C26.5397 30.6137 26.3931 30.8091 26.1 31.2L24.64 33.1467C24.4229 33.4362 24.3143 33.5809 24.1812 33.6327C24.0647 33.678 23.9353 33.678 23.8188 33.6327C23.6857 33.5809 23.5771 33.4362 23.36 33.1467L21.9 31.2C21.6069 30.8091 21.4603 30.6137 21.2815 30.4645C21.0431 30.2656 20.7617 30.1248 20.4595 30.0535C20.2329 30 19.9886 30 19.5 30C18.1022 30 17.4033 30 16.8519 29.7716C16.1169 29.4672 15.5328 28.8831 15.2284 28.1481C15 27.5967 15 26.8978 15 25.5V19.8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.a203881cecaad85a4db5fc82a6fdb5cc.svg";
export { ForwardRef as ReactComponent };